export default __webpack_public_path__ + "media/images/manual/joanr/11-ad660f3d77e7c7dbed6a178596d3ec22.png";